import { useEffect, useState } from "react";
import LoginModal from "./LoginModal";
import RegisterModal from "./RegisterModal";
import OTPInputModal from "./OTPInputModal";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { setRedirectUrl } from "store";

interface props {
  userLoggedin: any;
  authModelOpen: boolean;
  setAuthModelOpen: (open: boolean) => void;
}

export function AuthModalWrapper({
  userLoggedin,
  authModelOpen,
  setAuthModelOpen,
}: props) {
  const [loginModelOpen, setLoginModalOpen] = useState(false);
  const [inputModelOpen, setInputModalOpen] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);
  const [action, setAction] = useState("verifyRegistration");

  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    setLoginModalOpen(authModelOpen);
    if (authModelOpen) {
      dispatch(setRedirectUrl(router.asPath));
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [authModelOpen, router.asPath]);

  useEffect(() => {
    if (!loginModelOpen && !inputModelOpen && !registerModal) {
      setAuthModelOpen(false);
    }
  }, [loginModelOpen, inputModelOpen, registerModal]);

  return (
    <div>
      {loginModelOpen && (
        <LoginModal
          userLoggedin={userLoggedin}
          loginModelOpen={loginModelOpen}
          setRegisterModal={setRegisterModal}
          setInputModalOpen={setInputModalOpen}
          setLoginModalOpen={setLoginModalOpen}
          setAction={setAction}
        />
      )}
      {registerModal && (
        <RegisterModal
          userLoggedin={userLoggedin}
          registerModelOpen={registerModal}
          setRegisterModal={setRegisterModal}
          setInputModalOpen={setInputModalOpen}
          setLoginModalOpen={setLoginModalOpen}
          setAction={setAction}
        />
      )}
      {/* Modal for OTP input */}
      {inputModelOpen && (
        <OTPInputModal
          userLoggedin={userLoggedin}
          inputModelOpen={inputModelOpen}
          setInputModalOpen={setInputModalOpen}
          setLoginModalOpen={setLoginModalOpen}
          action={action}
        />
      )}
    </div>
  );
}
